var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.processedTableData,
            border: "",
            stripe: "",
            "header-cell-style": { background: "#f5f7fa" }
          }
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", prop: "i", label: "序号", width: "50" }
          }),
          _c("el-table-column", {
            attrs: { align: "center", prop: "notaryNo", label: "卷宗号" }
          }),
          _c("el-table-column", {
            attrs: { align: "center", prop: "dsr", label: "当事人" }
          }),
          _c("el-table-column", {
            attrs: { align: "center", prop: "dsrPhone", label: "联系电话" }
          }),
          _c("el-table-column", {
            attrs: { align: "center", prop: "itemName", label: "公证事项" }
          }),
          _c("el-table-column", {
            attrs: { align: "center", prop: "itemType", label: "公证类别" }
          }),
          _c("el-table-column", {
            attrs: { align: "center", prop: "createTime", label: "申请日期" }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "status_name",
              label: "流程状态",
              width: "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "right",
              label: "操作",
              width: "350"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "action-buttons" }, [
                      scope.row.STATUS > 6
                        ? _c(
                            "div",
                            { staticClass: "button-group" },
                            [
                              scope.row.executionType == 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "small" },
                                      on: {
                                        click: function($event) {
                                          return _vm.openZhiXingDialog(
                                            "edit",
                                            scope.row.id,
                                            scope.row.executionType,
                                            "heshihan"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              开始核实\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              scope.row.executionType == 2
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "small" },
                                      on: {
                                        click: function($event) {
                                          return _vm.openZhiXingDialog(
                                            "edit",
                                            scope.row.id,
                                            scope.row.executionType,
                                            "chuzheng"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              开始强执\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function($event) {
                                      return _vm.callVideo(scope.row.id)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              视频连线\n            "
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "danger", size: "small" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.noPass.open(
                                        scope.row.id,
                                        scope.row.STATUS
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              不予受理\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "button-group" },
                            [
                              [1, 2, 3, 4, -2, 5, 6, 7].includes(
                                scope.row.STATUS
                              )
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "small" },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleMainAction(scope.row)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.getMainButtonText(
                                              scope.row.STATUS
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function($event) {
                                      return _vm.callVideo(scope.row.id)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              视频连线\n            "
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "danger", size: "small" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.noPass.open(
                                        scope.row.id,
                                        scope.row.STATUS
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              不予受理\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        staticClass: "my-pagination",
        attrs: {
          background: "",
          "current-page": _vm.pageNum,
          "page-sizes": [10, 20, 30],
          "page-size": _vm.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange
        }
      }),
      _c("CaseInfo", {
        ref: "caseInfo",
        attrs: { openType: _vm.openType, currCaseId: _vm.currCaseId },
        on: {
          checkSuccess: _vm.createSuccess,
          createSuccess: _vm.createSuccess,
          noPass: _vm.handleNoPass
        }
      }),
      _c("CaseZhiXingInfo", {
        ref: "caseZhiXingInfo",
        attrs: { openType: _vm.openType, currCaseId: _vm.currCaseId },
        on: {
          checkSuccess: _vm.createSuccess,
          createSuccess: _vm.createSuccess
        }
      }),
      _c("FristExamine", {
        ref: "fristExamine",
        attrs: { currCaseId: _vm.currCaseId }
      }),
      _c("AcceptanceDialog", {
        ref: "acceptanceDialog",
        attrs: { currCaseId: _vm.currCaseId }
      }),
      _c("Evidence", { ref: "evidence" }),
      _c("CreateDoc", { ref: "createDoc" }),
      _c("NoPass", {
        ref: "noPass",
        on: {
          success: _vm.handleNoPassSuccess,
          checkSuccess: _vm.createSuccess
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }